import React from "react"
import styled from "styled-components"
import CommonIcon from "@/components/common/Icon/Icon"
import { ICONS } from "@/constants"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"
import { getCssSizeValue, getMapKey } from "@/utils/utils"

const FilesBlocksWrapper = styled.div`
	padding-top: ${getCssSizeValue(16, BREAKPOINTS.DESKTOP)};
	padding-bottom: ${getCssSizeValue(48, BREAKPOINTS.DESKTOP)};
	display: flex;
	flex-direction: column;
	gap: ${getCssSizeValue(16)};
	width: fit-content;
`

const StyledSingleFileBlockWrapper = styled.div`
	display: block;
	border: 1px solid var(--color);
	width: fit-content;
	--color: ${({ theme }) => theme.colors.richBlack};

	transition: all var(--rgr-duration) var(--ease);

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		&:hover {
			background: ${({ theme }) => theme.colors.periwinkle};
		}
	}

	&.gap {
		margin-bottom: ${getCssSizeValue(16)};
	}
`

const StyledSingleFileBlock = styled.a`
	cursor: pointer;
	display: flex;
	gap: ${getCssSizeValue(24)};
	align-items: center;
	border: 1px solid var(--color);
	padding: ${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(54, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(13)} ${getCssSizeValue(54)} ${getCssSizeValue(13)} ${getCssSizeValue(16)};
	}

	p {
		color: var(--color) !important;
		text-decoration: none;
	}
`

const Icon = styled(CommonIcon)`
	width: ${getCssSizeValue(14, BREAKPOINTS.DESKTOP)};
`

export function SingleDownloadBlock({ fileName, fileUrl, asRedactor = false, gap = false }) {
	return (
		<StyledSingleFileBlockWrapper className={gap ? "gap" : ""}>
			<StyledSingleFileBlock href={fileUrl} target="_blank" rel="noopener noreferrer" download>
				<Icon name={ICONS.ATTACHMENT} color={colors.richBlack} />
				{asRedactor ? (
					<div className="typo-strawford typo-strawford-12" dangerouslySetInnerHTML={fileName} />
				) : (
					<p className="typo-strawford typo-strawford-12">{fileName}</p>
				)}
			</StyledSingleFileBlock>
		</StyledSingleFileBlockWrapper>
	)
}

const SingleNewsVariant = ({ data }) => {
	const filesBlocks = data?.downloadFilesBlocks || []
	return (
		<FilesBlocksWrapper className="download-files">
			{filesBlocks.map((item, index) => {
				const fileName = item?.fileVisibleName || ""
				const fileUrl = item?.file?.url || ""
				return <SingleDownloadBlock key={getMapKey(item, index)} fileName={fileName} fileUrl={fileUrl} />
			})}
		</FilesBlocksWrapper>
	)
}

export default SingleNewsVariant
